/**
 * A global namespace for `mouseout` event.
 */
const mouseoutEvent = "mouseout";
export default mouseoutEvent;
